import { Application } from '../models';
import { ApplicationsDetailsState } from '../reducers/applications-details.reducer';
import { FormResult } from '@eBeihilfe/einreichung-shared/model';
import { Injectable, Signal, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { applicationsDetailsActions } from '../actions';
import {
  selectApplicationsDetailsData,
  selectApplicationsDetailsError,
  selectApplicationsDetailsLoading,
  selectDocumentById,
} from '../selectors';

@Injectable()
export class ApplicationsDetailsFacade {
  private readonly store: Store<ApplicationsDetailsState> = inject(Store);

  public clearStore(): void {
    this.store.dispatch(applicationsDetailsActions.clearStore());
  }

  public deleteDocumentById(id: string): void {
    this.store.dispatch(applicationsDetailsActions.deleteDocumentById({ id }));
  }

  public loadData(applicationId: string): void {
    this.store.dispatch(applicationsDetailsActions.load({ applicationId }));
  }

  public selectData(): Signal<Application> {
    return this.store.selectSignal(selectApplicationsDetailsData);
  }

  public selectData$(): Observable<Application> {
    return this.store.select(selectApplicationsDetailsData);
  }

  public selectDocumentById(): Signal<FormResult[] | null> {
    return this.store.selectSignal(selectDocumentById);
  }

  public selectDocumentById$(): Observable<FormResult[] | null> {
    return this.store.select(selectDocumentById);
  }

  public selectError$(): Observable<{
    message: string;
    type: ReturnType<typeof applicationsDetailsActions.loadFailed>;
  }> {
    return this.store.select(selectApplicationsDetailsError);
  }

  public selectLoading(): Signal<boolean> {
    return this.store.selectSignal(selectApplicationsDetailsLoading);
  }
}
